import zulip from './zulip'

export default {
  zulip
}
